<section *ngIf="profile">

  <!-- Profile avatar button -->
  <img
    *ngIf="profile.picture; else initialsAvatar"
    [matMenuTriggerFor]="appMenu"
    [src]="profile.picture"
    alt="profile"
    class="mat-fab profile"
  >
  <ng-template #initialsAvatar>
    <div [matMenuTriggerFor]="appMenu" class="mat-fab profile initials-avatar">
      {{ profile.name?.charAt(0)?.toUpperCase() }}
    </div>
  </ng-template>

  <!-- Dropdown menu -->
  <mat-menu #appMenu="matMenu">
    <section class="profile-details" fxLayout="column">

      <img *ngIf="profile.picture" [src]="profile.picture" alt="profile">

      <p>{{ profile.name }}</p>
      <p class="email">{{ profile.email }}</p>

    </section>

    <mat-divider></mat-divider>

    <button mat-menu-item (click)="logout()">
      Logout
    </button>

  </mat-menu>

</section>
